import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { 
    registerService, 
    loginService, 
    logoutService, 
    verifyEmailService,
    resendVerificationService,
    forgotPasswordService,
    resetPasswordService,
    changePasswordService,
    getProfileService,
    updateProfileService
} from "../services/auth-service";
import { User, ApiResponse } from "../types/user";

export function useRegister() {
  return useMutation({
    mutationKey: ['register'],
    mutationFn: registerService,
  });
}

export function useLogin() {
  return useMutation({
    mutationKey: ['login'],
    mutationFn: loginService,
  });
}

export function useLogout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['logout'],
    mutationFn: logoutService,
    onSuccess: () => {
        queryClient.clear();
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
    }
  });
}

export function useVerifyEmail() {
  return useMutation({
    mutationKey: ['verify-email'],
    mutationFn: verifyEmailService,
  });
}

export function useResendVerification() {
  return useMutation({
    mutationKey: ['resend-verification'],
    mutationFn: resendVerificationService,
  });
}

export function useForgotPassword() {
  return useMutation({
    mutationKey: ['forgot-password'],
    mutationFn: forgotPasswordService,
  });
}

export function useResetPassword() {
  return useMutation({
    mutationKey: ['reset-password'],
    mutationFn: resetPasswordService,
  });
}

export function useChangePassword() {
  return useMutation({
    mutationKey: ['change-password'],
    mutationFn: changePasswordService,
  });
}

export function useGetProfile(options?: any) {
  return useQuery<ApiResponse<User>, Error>({
    queryKey: ['user-profile'],
    queryFn: getProfileService,
    retry: false,
    ...options
  });
}

export function useUpdateProfile() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['update-profile'],
        mutationFn: updateProfileService,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['user-profile'] });
        }
    });
}
